// Limpia el localStorage al cerrar sesión (logout explícito en modules/login/actions.js, o el
// logout forzado del interceptor 401 en axios/index.js) SIN borrar las claves de layout del
// dashboard "INDICADORES" (dashboard_kpis_layout_{userId}/dashboard_charts_layout_{userId}, ver
// components/dashboard-sale-indicators/layoutStorage.js) — pedido explícito: el orden/tamaño que
// el usuario dejó armado debe sobrevivir a un cierre de sesión, no solo a un refresh de página.
// Antes ambos call sites hacían localStorage.clear() a secas, que también borraba estas claves.
// También se preserva el tema claro/oscuro del dashboard ('dashboard_sale_indicators_theme', ver
// THEME_STORAGE_KEY en components/dashboard-sale-indicators/theme.js — debe ser la misma llave).
// También la copia local del último dashboard ('dashboard_sale_indicators_cache', una sola copia, ver
// CACHE_KEY en components/dashboard-sale-indicators/dashboardCache.js — misma llave): se muestra al
// entrar de nuevo mientras llegan los datos frescos, así que debe sobrevivir al logout.
const PRESERVED_KEY_PREFIXES = ['dashboard_kpis_layout_', 'dashboard_charts_layout_', 'dashboard_sale_indicators_theme', 'dashboard_sale_indicators_cache']

export function clearSessionStorage() {
    try {
        const keysToRemove = []

        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i)

            if (key && !PRESERVED_KEY_PREFIXES.some(prefix => key.indexOf(prefix) === 0)) {
                keysToRemove.push(key)
            }
        }

        keysToRemove.forEach(key => localStorage.removeItem(key))
    } catch (e) {
        // No-op: si localStorage no está disponible no hay nada que limpiar.
    }
}



// WEBPACK FOOTER //
// ./src/util/sessionStorageCleanup.js